import React, { useCallback } from 'react';

import call from 'utils/functions/call.util';

// DEPRECATED: remove this component and use src/components/form/CheckboxInput.component instead
const Checkbox = ({ disabled, id, isChecked, onCheckboxClick }) => {
  const handleChange = useCallback(
    //
    (ev) => void call('Checkbox.onCheckboxClick', onCheckboxClick, ev.target.checked),
    [onCheckboxClick],
  );

  return (
    <div data-bem="Checkbox--dropdown" className="outer-div">
      <label data-bem="Checkbox__label" className="square" htmlFor={id}>
        <input
          data-bem="Checkbox__input"
          type="checkbox"
          className="aaa"
          id={id}
          checked={isChecked}
          disabled={disabled}
          onChange={handleChange}
        />
        <span />
      </label>
    </div>
  );
};

export default Checkbox;
